<template>

    <yandex-map 
    :coords="coords" 
    :settings="settings"
    :zoom="14"
    :controls="controls"
    :scroll-zoom="false"
    @map-was-initialized="mapInitialized"
    >
      <ymap-marker 
        marker-id="123" 
        :coords="coords"
        :balloon-template="balloonTemplate"
      ></ymap-marker>
    </yandex-map>


</template>
<script>
import Vue from 'vue'
import Vuex from 'vuex'
import router from 'vue-router'
import { yandexMap, ymapMarker } from 'vue-yandex-maps'

Vue.use(Vuex)

export default {
  name: 'YandexMapContacts',
  components: { 
    yandexMap, 
    ymapMarker 
    },
    props: ['heigtMap'],
  data () {
    return {
        coords: [55.707270, 37.589912],
        markerIcon: {
          layout: 'default#imageWithContent',
          imageHref: 'https://image.flaticon.com/icons/png/512/33/33447.png',
          imageSize: [43, 43],
          imageOffset: [0, 0],
          content: '123 v12',
          contentOffset: [0, 15],
          contentLayout: '<div style="background: red; width: 50px; color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
        },
        controls: ['fullscreenControl','zoomControl','trafficControl'],
        settings : {
          apiKey: '9bb7850a-030f-458b-b7bb-5a0692f305d3',
          lang: 'ru_RU',
          coordorder: 'latlong',
          version: '2.1',
           
        },

    }
  },
     computed:{
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },       
        balloonTemplate() {
            return `<h3>ТРЦ Гагаринский</h3>  `
          },

     },  
  methods: {
     mapInitialized(paiload){
if(DEBUG) console.log('map init :',yandexMap);
let currMap = paiload;


currMap.controls.add('routeButtonControl', {
    size: "large",
    float: "left",
    floatIndex: 1000,
    position:{left:50, top:10}
});

currMap.controls.get('routeButtonControl')
    .routePanel.state.set({
    toEnabled: false,    
    from:'',
    to: "Москва, ул. Вавилова, 3",
    type: "auto",
    });


if(DEBUG) console.log('map init paiload :',paiload);
//if(DEBUG) console.log('map init routePanel :',routePanel);
//if(DEBUG) console.log('map init routePanel getAll:',routePanel.options.getAll());
/* routePanel.options.set(
  'adjustMapMargin', true
  ); */



     }

     },

}
</script>


<style scoped>

</style>